import LoadingAnimation from 'components/TemplateOptions/LoadingAnimation';
import "./LoadingSplash.scss";

export default function LoadingSplash() {
  return (
    <LoadingAnimation render={true} />
  );
}
